
import { useTranslation } from 'react-i18next';
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";

export const OverviewSection = () => {
  const { t } = useTranslation();

  const benefits = [
    { title: t('plans_detail.keieisha_hosho.benefit_0_title'), desc: t('plans_detail.keieisha_hosho.benefit_0_desc') },
    { title: t('plans_detail.keieisha_hosho.benefit_1_title'), desc: t('plans_detail.keieisha_hosho.benefit_1_desc') },
    { title: t('plans_detail.keieisha_hosho.benefit_2_title'), desc: t('plans_detail.keieisha_hosho.benefit_2_desc') },
  ];

  const guidelines = [
    t('plans_detail.keieisha_hosho.guideline_0'),
    t('plans_detail.keieisha_hosho.guideline_1'),
    t('plans_detail.keieisha_hosho.guideline_2'),
    t('plans_detail.keieisha_hosho.guideline_3'),
    t('plans_detail.keieisha_hosho.guideline_4'),
  ];

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 mt-8 text-white">{t('plans_detail.common.overview')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.keieisha_hosho.overview_p1')}
        </p>
        <p className="mb-8 text-white/70 leading-relaxed">
          {t('plans_detail.keieisha_hosho.overview_p2')}
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.keieisha_hosho.benefits_title')}</h2>
        <motion.div
          className="space-y-4 mb-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08 } } }}
        >
          {benefits.map(({ title, desc }) => (
            <motion.div
              key={title}
              variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } }}
              whileHover={{ scale: 1.02 }}
              className="border border-white/10 bg-white/5 p-6 rounded-xl flex items-start gap-4"
            >
              <CheckCircle className="text-[#c9a84c] mt-1 h-6 w-6 flex-shrink-0" />
              <div>
                <h3 className="font-bold text-lg mb-2 text-white">{title}</h3>
                <p className="text-white/65 leading-relaxed">{desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.keieisha_hosho.guidelines_title')}</h2>
        <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70">
          {guidelines.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </motion.section>
    </>
  );
};
